module.exports = __webpack_public_path__ + "img/value_img.0fc94e93.png";